export default __webpack_public_path__ + "static/shostakovich-e-dur-c7ae275a8cb6eb202adeb66e8397b7c6.mp3";